<template>
<div v-if="camera.devices && (camera.camera_type === 'alarm_bridge_dmp' || camera.camera_type === 'alarm_bridge_bosch')">
    <div v-for="key in filteredDeviceKeys" :key="key">

    <!-- Areas -->
    <div v-if="key === 'areas'">
        <div v-for="(area, indexArea) in camera.devices[key]" :key="indexArea" style="margin: 0px;">
        <b-card no-body style="margin: 0px;">
            <b-card-header header-tag="div" class="p-0 border rounded">
            <b-button
                block
                v-b-toggle="`collapse-area-${camera.camera_proxy_id}-${indexArea}`"
                variant="link"
                style="padding-top: 10px; padding-bottom: 10px;"
                class="text-left d-flex justify-content-between align-items-center px-1"
                size="sm"
                :draggable="!usedDeviceIds.has(getCameraProxyId(area))"
                :style="usedDeviceIds.has(getCameraProxyId(area)) ? { opacity: 0.4 } : {}"
                @dragstart.stop="!usedDeviceIds.has(getCameraProxyId(area)) && emitDrag(area)"
            >
                <div class="d-flex align-items-center">
                <template v-if="getItemAlarmStyle(area)">
                <CustomIcon
                    :name="getItemAlarmStyle(area).icon"
                    :size="16"
                    :color="getItemAlarmStyle(area).color"
                />
                </template>
                <img v-else :src="setImage(area)" width="16px" />
                <span class="status-dot" style="flex-shrink:0;"></span>
                <span class="device-name" style="font-size:13px;" v-b-tooltip.hover :title="area.text">
                    {{ area.text ? (area.text.length > 12 ? area.text.substring(0, 12) + '...' : area.text) : '' }}
                    <small class="text-muted">(area)</small>
                </span>
                </div>
                <feather-icon icon="ChevronDownIcon" size="12" />
            </b-button>
            </b-card-header>

            <!-- Sin accordion — sub-collapse independiente -->
            <b-collapse :id="`collapse-area-${camera.camera_proxy_id}-${indexArea}`">
            <b-card-body style="background: #f8f9fa; padding: 1px;">
                <div
                v-for="areaDevice in area.devices"
                :key="areaDevice.id"
                class="device-item d-flex justify-content-start align-items-center border rounded"
                style="margin: 3px; background: white;"
                :draggable="!usedDeviceIds.has(getCameraProxyId(areaDevice))"
                :style="usedDeviceIds.has(getCameraProxyId(areaDevice))
                    ? { opacity: 0.4, cursor: 'not-allowed' }
                    : { cursor: 'grab' }"
                @dragstart.stop="!usedDeviceIds.has(getCameraProxyId(areaDevice)) && emitDrag(areaDevice)"
                >
                <template v-if="getItemAlarmStyle(areaDevice)">
                <CustomIcon
                    :name="getItemAlarmStyle(areaDevice).icon"
                    :size="16"
                    :color="getItemAlarmStyle(areaDevice).color"
                />
                </template>
                <img v-else :src="setImage(areaDevice)" width="16px" />
                <span class="status-dot" style="flex-shrink:0;"></span>
                <span class="device-name" style="font-size:12px;" v-b-tooltip.hover :title="areaDevice.text">
                    {{ areaDevice.text ? (areaDevice.text.length > 18 ? areaDevice.text.substring(0, 18) + '...' : areaDevice.text) : '' }}
                </span>
                </div>
            </b-card-body>
            </b-collapse>
        </b-card>
        </div>
    </div>

    <!-- DMP Panel Status -->
    <div v-else-if="key === 'dmp_panel_status'" style="margin: 0px;">
        <b-card no-body style="margin: 0px;">
            <b-card-header header-tag="div" class="p-0 border rounded">
                <b-button
                    block
                    v-b-toggle="`collapse-dmp-status-${camera.camera_proxy_id}`"
                    variant="link"
                    style="padding-top: 10px; padding-bottom: 10px;"
                    class="text-left d-flex justify-content-between align-items-center px-1"
                    size="sm"
                >
                    <div class="d-flex align-items-center">
                        <feather-icon icon="ActivityIcon" size="14" class="mr-1" />
                        <span class="device-name" style="font-size:13px;">Estado del Panel</span>
                    </div>
                    <feather-icon icon="ChevronDownIcon" size="12" />
                </b-button>
            </b-card-header>

            <b-collapse :id="`collapse-dmp-status-${camera.camera_proxy_id}`">
                <b-card-body style="background: #f8f9fa; padding: 1px;">
                    <div
                    v-for="statusItem in filteredDmpStatuses"
                    :key="statusItem.id"
                    class="device-item d-flex justify-content-start align-items-center border rounded"
                    style="margin: 3px; background: white;"
                    :draggable="!usedDeviceIds.has(statusItem.id)"
                    :style="usedDeviceIds.has(statusItem.id)
                        ? { opacity: 0.4, cursor: 'not-allowed' }
                        : { cursor: 'grab' }"
                    @dragstart.stop="!usedDeviceIds.has(statusItem.id) && emitDragStatus(statusItem)"
                    >
                    <!-- CustomIcon para Tamper, Alimentación CA, Batería -->
                    <CustomIcon
                        v-if="isCustomDmpIcon(statusItem)"
                        :name="getDmpStatusIcon(statusItem)"
                        :size="20"
                        :color="statusItem.data.value === 'Falla' ? '#cf1111' : '#6c757d'"
                        style="margin-right: 4px; flex-shrink: 0;"
                    />
                    <!-- Feather icon para Impresora y otros -->
                    <i
                        v-else
                        :class="statusItem.data.icon"
                        style="font-size: 14px; margin-right: 4px; flex-shrink: 0;"
                    />

                    <span class="device-name" style="font-size:12px;" v-b-tooltip.hover :title="statusItem.data.name">
                        {{ statusItem.data.name.length > 18 ? statusItem.data.name.substring(0, 18) + '...' : statusItem.data.name }}
                    </span>
                    <b-badge
                        class="ml-auto"
                        :variant="statusItem.data.value === 'Normal' ? 'success' : 'danger'"
                        style="font-size: 9px;"
                    >
                        {{ statusItem.data.value }}
                    </b-badge>
                    </div>
                </b-card-body>
            </b-collapse>
        </b-card>
    </div>

    <!-- DMP Panel Actions -->
    <div v-else-if="key === 'dmp_panel_actions'" style="margin: 0px;">
        <b-card no-body style="margin: 0px;">
            <b-card-header header-tag="div" class="p-0 border rounded">
            <b-button
                block
                v-b-toggle="`collapse-dmp-actions-${camera.camera_proxy_id}`"
                variant="link"
                style="padding-top: 10px; padding-bottom: 10px;"
                class="text-left d-flex justify-content-between align-items-center px-1"
                size="sm"
            >
                <div class="d-flex align-items-center">
                <feather-icon icon="ZapIcon" size="14" class="mr-1" />
                <span class="device-name" style="font-size:13px;">Acciones del Panel</span>
                </div>
                <feather-icon icon="ChevronDownIcon" size="12" />
            </b-button>
            </b-card-header>

            <b-collapse :id="`collapse-dmp-actions-${camera.camera_proxy_id}`">
            <b-card-body style="background: #f8f9fa; padding: 1px;">
                <div
                v-for="actionItem in filteredDmpActions"
                :key="actionItem.id"
                class="device-item d-flex justify-content-start align-items-center border rounded"
                style="margin: 3px; background: white;"
                :draggable="!usedDeviceIds.has(actionItem.id)"
                :style="usedDeviceIds.has(actionItem.id)
                    ? { opacity: 0.4, cursor: 'not-allowed' }
                    : { cursor: 'grab' }"
                @dragstart.stop="!usedDeviceIds.has(actionItem.id) && emitDragAction(actionItem)"
                >
                <i :class="actionItem.data.icon" style="font-size: 14px; margin-right: 4px;" />
                <span class="device-name" style="font-size:12px;" v-b-tooltip.hover :title="actionItem.data.name">
                    {{ actionItem.data.name.length > 18 ? actionItem.data.name.substring(0, 18) + '...' : actionItem.data.name }}
                </span>
                </div>
            </b-card-body>
            </b-collapse>
        </b-card>
    </div>

    <!-- Panel -->
    <div
        v-else-if="key === 'panel'"
        class="device-item d-flex justify-content-start align-items-center border rounded px-1"
        style="margin: 0px; padding-top: 10px; padding-bottom: 10px; background: white;"
        :draggable="!usedDeviceIds.has(getCameraProxyId(camera.devices[key]))"
        :style="usedDeviceIds.has(getCameraProxyId(camera.devices[key]))
        ? { opacity: 0.4, cursor: 'not-allowed' }
        : { cursor: 'grab' }"
        @dragstart.stop="!usedDeviceIds.has(getCameraProxyId(camera.devices[key])) && emitDrag(camera.devices[key])"
    >
        <div class="d-flex align-items-center">
            <img :src="setImage(camera)" width="16px" />
            <span class="status-dot" style="flex-shrink:0;"></span>
            <span class="device-name" style="font-size:13px;">Panel</span>
        </div>
    </div>

    <!-- Otros (doors, outputs, etc) — sin zones -->
    <div v-else-if="key !== 'zones'" style="margin: 0px;">
        <b-card no-body style="margin: 0px;">
        <b-card-header header-tag="div" class="p-0 border rounded">
            <b-button
            block
            v-b-toggle="`collapse-zone-${camera.camera_proxy_id}-${key}`"
            variant="link"
            style="padding-top: 10px; padding-bottom: 10px;"
            class="text-left d-flex justify-content-between align-items-center px-1"
            size="sm"
            >
            <div class="d-flex align-items-center">
                <img :src="setImage(camera)" width="16px"/>
                <span class="device-name" style="font-size:13px;">{{ key }}</span>
            </div>
            <feather-icon icon="ChevronDownIcon" size="12" />
            </b-button>
        </b-card-header>

        <!-- Sin accordion -->
        <b-collapse :id="`collapse-zone-${camera.camera_proxy_id}-${key}`">
            <b-card-body style="background: #f8f9fa; padding: 1px;">
            <div
                v-for="type in camera.devices[key]"
                :key="type.id"
                class="device-item d-flex justify-content-start align-items-center border rounded"
                style="margin: 3px; background: white;"
                :draggable="!usedDeviceIds.has(getCameraProxyId(type))"
                :style="usedDeviceIds.has(getCameraProxyId(type))
                ? { opacity: 0.4, cursor: 'not-allowed' }
                : { cursor: 'grab' }"
                @dragstart.stop="!usedDeviceIds.has(getCameraProxyId(type)) && emitDrag(type)"
            >
                <template v-if="getItemAlarmStyle(type)">
                <CustomIcon
                    :name="getItemAlarmStyle(type).icon"
                    :size="16"
                    :color="getItemAlarmStyle(type).color"
                />
                </template>
                <img v-else :src="setImage(type)" width="16px" />
                <span class="status-dot" style="flex-shrink:0;"></span>
                <span class="device-name" style="font-size:12px;" v-b-tooltip.hover :title="type.text">
                {{ type.text ? (type.text.length > 18 ? type.text.substring(0, 18) + '...' : type.text) : '' }}
                </span>
            </div>
            </b-card-body>
        </b-collapse>
        </b-card>
    </div>

    </div>
</div>
</template>

<script>
export default {
name: "AlarmBridgeBosch",
props: {
    camera:        { type: Object,   required: true },
    setImage:      { type: Function, required: true },
    usedDeviceIds: { default: () => new Set() },
    cameraList:    { type: Array,    default: () => [] },
    hideHeader:    { type: Boolean,  default: false },
    filter: { type: String, default: '' },
},
components: {
  CustomIcon: () => import('@/components/CustomIcon.vue'),
},
computed: {
    filteredDeviceKeys() {
    if (!this.filter || !this.camera.devices) return Object.keys(this.camera.devices)
    return Object.keys(this.camera.devices).filter(key => {
        const val = this.camera.devices[key]
        if (key === 'panel') return this.camera.name?.toLowerCase().includes(this.filter.toLowerCase())
        
        if (key === 'dmp_panel_status') {
        return Array.isArray(val) && val.some(item =>
            item.data?.name?.toLowerCase().includes(this.filter.toLowerCase())
        )
        }

        if (Array.isArray(val)) {
        return val.some(item =>
            item.text?.toLowerCase().includes(this.filter.toLowerCase()) ||
            (item.devices || []).some(sub => sub.text?.toLowerCase().includes(this.filter.toLowerCase()))
        )
        }
        return true
    })
    },
    filteredDmpStatuses() {
    const items = this.camera.devices?.dmp_panel_status || []
    if (!this.filter) return items
    return items.filter(s =>
        s.data?.name?.toLowerCase().includes(this.filter.toLowerCase())
    )
    },
    filteredDmpActions() {
    const items = this.camera.devices?.dmp_panel_actions || []
    if (!this.filter) return items
    return items.filter(a =>
        a.data?.name?.toLowerCase().includes(this.filter.toLowerCase())
    )
    },
},
data() {
    return { hoveredItem: null }
},
methods: {
    getDmpStatusIcon(statusItem) {
    const value = statusItem.data?.value || 'Normal'
    const isFalla = value === 'Falla'

    const iconMap = {
        'dmp-status-1': isFalla ? 'GabinetePanelAbiertoEnActivacion' : 'GabinetePanelAbierto',  // Tamper
        'dmp-status-2': 'FallaEnEnergia',                                                         // Alimentación CA
        'dmp-status-3': isFalla ? 'BateriaPanelEnActivacion' : 'BateriaPanel',                   // Batería
    }
    return iconMap[statusItem.id] || null
    },

    isCustomDmpIcon(statusItem) {
    return !!this.getDmpStatusIcon(statusItem)
    },
    getItemAlarmStyle(item) {
    const deviceTag = item.device_tag
    if (deviceTag?.icon) {
        return { icon: deviceTag.icon, color: deviceTag.icon_color || '#9e9e9e' }
    }

    const alarm = item.latest_alarm
    if (!alarm || Array.isArray(alarm)) return null

    const tagIcon   = alarm.tag  && alarm.tag.icon       ? alarm.tag.icon       : null
    const tagColor  = alarm.tag  && alarm.tag.icon_color  ? alarm.tag.icon_color  : null
    const ruleIcon  = alarm.rule && alarm.rule.icon       ? alarm.rule.icon       : null
    const ruleColor = alarm.rule && alarm.rule.color      ? alarm.rule.color      : null

    if (tagIcon) return { icon: tagIcon, color: tagColor || '#9e9e9e' }
    if (ruleIcon) return { icon: ruleIcon, color: ruleColor || '#9e9e9e' }
    return null
    },
    getCameraProxyId(device) {
    if (device.device_proxy_id) return device.device_proxy_id
    const match = this.cameraList.find(c => c.id === device.device_id || c.id === device.id)
    return match?.camera_proxy_id ?? match?.id_camera_proxy ?? device.id
    },
    emitDrag(device) {
    const proxyId = device.device_proxy_id ?? null
    const match = this.cameraList.find(c => c.name === device.text || c.id === device.device_id)
    const camera_proxy_id = proxyId ?? match?.camera_proxy_id ?? match?.id_camera_proxy ?? null
    this.$emit('drag-device', {
        ...device,
        name:              device.text,
        id_camera_proxy:   camera_proxy_id,
        camera_proxy_id:   camera_proxy_id,
        device_type:       match?.device_type ?? device.device_type ?? null,
        camera_type:       match?.camera_type ?? null,
        panel_device_type: device.device_type,
    })
    },
    emitDragStatus(statusItem) {
    const customIcon = this.getDmpStatusIcon(statusItem) 
    this.$emit('drag-device', {
        id:              statusItem.id,
        id_generic:      statusItem.id,
        id_camera_proxy: null,
        camera_proxy_id: null,
        name:            statusItem.data.name,
        device_type:     'dmp_panel_status',
        camera_type:     'dmp_panel_status',
        panel_device_type: 'dmp_panel_status',
        icon:            customIcon || statusItem.data.icon,
        isCustomIcon:    !!customIcon,
        value:           statusItem.data.value,
        color:           statusItem.data.color     || null,
        color_icon:      statusItem.data.color_icon || null,
        text_color:      statusItem.data.text_color || null,
    })
    },
    emitDragAction(actionItem) {
    this.$emit('drag-device', {
        id:              actionItem.id,
        id_generic:      actionItem.id,
        id_camera_proxy: null,
        camera_proxy_id: null,
        name:            actionItem.data.name,
        device_type:     'dmp_panel_action',
        camera_type:     'dmp_panel_action',
        panel_device_type: 'dmp_panel_action',
        icon:            actionItem.data.icon,
        color:           actionItem.data.color    || null,
        color_icon:      actionItem.data.color_icon || null,
        text_color:      actionItem.data.text_color || null,
        actions:         actionItem.actions        || {},
    })
    },
}
}
</script>

<style scoped>
.device-item { padding: 5px; cursor: pointer; transition: background 0.2s ease; }
.device-item:hover { background: #f4f4f4; }
.device-item img { transition: transform 0.2s ease; }
.device-item:hover img { transform: scale(1.1); }
.device-name { font-size: 14px; padding-left: 5px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.status-dot { width: 8px; height: 8px; border-radius: 50%; margin-left: 5px; background-color: #28a745; display: inline-block; }
.status-dot.off { background-color: #dc3545; }
</style>
